import { Control } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import { PatientInput } from '../../../generated/graphql';
import { DemographicFormValues } from './demographics-form';
import {
  AssessmentCard,
  ControlledSelectField,
  ControlledTextField,
} from '../shared';
import { rules } from './rules';
import { stateOptions } from '../../../helpers/states';

type PropTypes = {
  control: Control<DemographicFormValues, any>;
  patient: PatientInput;
  showSexField: boolean;
};

export const DemographicsAddress = ({
  control,
  patient,
  showSexField,
}: PropTypes) => (
  <AssessmentCard>
    <Grid container columnSpacing={1} rowSpacing={2}>
      {showSexField && (
        <Grid item xs={12}>
          <Typography component="h3" variant="h5">
            Primary address
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <ControlledTextField<DemographicFormValues>
          name="addressStreet1"
          control={control}
          defaultValue={patient.addressStreet1 ?? ''}
          rules={rules.addressStreet1}
          autoComplete="on"
          label="Primary street address"
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ControlledTextField<DemographicFormValues>
          name="addressStreet2"
          control={control}
          defaultValue={patient.addressStreet2 ?? ''}
          autoComplete="on"
          label="Apt, suite, etc. (optional)"
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField<DemographicFormValues>
          name="addressCity"
          control={control}
          defaultValue={patient.addressCity ?? ''}
          rules={rules.addressCity}
          autoComplete="on"
          label="City"
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ControlledSelectField<DemographicFormValues>
          name="addressState"
          control={control}
          defaultValue={patient.addressState ?? ''}
          rules={rules.addressState}
          label="State"
          options={stateOptions}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ControlledTextField<DemographicFormValues>
          name="addressZipCode"
          control={control}
          defaultValue={patient.addressZipCode ?? ''}
          rules={rules.addressZipCode}
          autoComplete="on"
          inputMode="numeric"
          label="ZIP"
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
    </Grid>
  </AssessmentCard>
);
